export const ENVIRONMENTS = [
    "Start-up",
    "Business Casual",
    "Business Traditional",
    "University",
    "High-school",
    "Free-time",
];
export const SHIRT_SIZES = [
    "XS",
    "XS,S",
    "S",
    "S,M",
    "M",
    "M,L",
    "L",
    "L,XL",
    "XL",
    "XL,XXL",
    "XXL",
    "XXL,XXXL",
    "XXXL",
    "ONESIZE"
];
export const DENIM_SIZES = [
    "34",
    "34,36",
    "36",
    "36,38",
    "38",
    "38,40",
    "40",
    "40,42",
    "42",
    "42,44",
    "44",
    "44,46",
    "46",
    "ONESIZE"
];
export const AGES = ["18-24", "25-34", "35-44", "45-54", "55+"];
export const DELIVERY_WEEKS = ["Week 1", "Week 2", "Week 3", "Week 4"];
export const DISTRIBUTION_PARTNERS = ["Airmee", "DB Schenker", "GLS"];
export const TYPE_OF_CLOTHES = [
    "I prefer basics.",
    "I have basics, I need something more.",
    "I would like a mix",
    "I want complete outfits",
];
export const FEEL_IN_CLOTHES = [
    "Professional",
    "Casual",
    "Comfortable",
    "Feminine",
    "Non-binary",
    "Trendy",
];
export const LOOK_AT_CLOTHES = [
    "Prints",
    "Bright Colors",
    "Dark Colors",
    "Light Colors",
    "Minimal Tones",
    "Edgy Details",
];
export const CUT_OF_TOPS = [
    "Long",
    "Cropped",
    "Tight",
    "Loose",
    "Classic",
    "Oversized",
    "C-collar",
    "V-collar",
];
export const CUT_OF_DRESSES = [
    "Loose",
    "High waist",
    "Long",
    "Classic Length",
    "Tight",
    "Short",
];
export const FAVOURITE_PULLOVER = [
    "Turtle-necks",
    "Jumpers",
    "Cardigans",
    "Long-lines",
];
export const PRINT_NOGO = [
    "Lace",
    "Polka Dots",
    "Animal Prints",
    "Stripes",
    "Retro Prints",
    "Flower Prints",
    "Geometric Prints",
    "Checked Prints",
];
export const COLORS_NOGO = [
    "Purple",
    "Beige",
    "Pink",
    "Red",
    "Silver",
    "Brown",
    "Orange",
    "Green",
    "Gold",
    "White",
    "Yellow",
    "Blue",
    "Grey",
    "Black",
];
export const FIT_BODY_SHAPE = [
    "Large hips",
    "Small waist",
    "Broad shoulders",
    "Round Waist",
    "Broad chest",
    "Long arms",
];
export const STYLE_PREFERENCE = [
    "MONKI",
    "COS",
    "VILA",
    "ZARA",
    "ADIDAS",
    "LEVI'S",
    "WEEKDAY",
    "FILIPPA K",
    "MANGO",
    "CARIN WESTER",
    "NA-KD",
    "& OTHER STORIES",
    "ÅHLENS",
    "SAMSOE & SAMSOE",
    "VINTAGE/ RETRO",
    "Other",
];
export const JEWELRY_TONE = [
    "Gold",
    "Silver",
    "Both"
];
export const GOALS_SERVICE = [
    "Options to wear",
    "Fun with clothes",
    "Conveniency",
    "Activism"
];
export const GOALS_IMPACT = [
    "My carbon footprint",
    "My spendings",
    "The time I spend shopping"
];

